import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * A small spinner animation with a circle spinning in another circle
 */
@Component({
  selector: 'mb-small-spinner',
  template: `
    <svg
      [attr.width]="size"
      [attr.height]="size"
      [attr.viewPort]="'0 0 ' + size + ' ' + size"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="bar"
        [attr.r]="radius / 2"
        [attr.cx]="radius"
        [attr.cy]="radius"
        fill="transparent"
        [attr.transform]="'rotate(-90 ' + radius + ' ' + radius + ')'"
        pathLength="32"
      ></circle>
      <circle class="outer" [attr.r]="radius * 0.8" [attr.cx]="radius" [attr.cy]="radius" fill="transparent"></circle>
    </svg>
  `,
  styleUrls: ['./small-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallSpinnerComponent {
  private _size = 20;
  radius = 10;

  @Input()
  set size(size: number) {
    this._size = size;
    this.radius = size / 2;
  }

  get size(): number {
    return this._size;
  }
}
